import { EntityType, ErrorState } from "Store/interfaces/products";

export type AddressSuggestionsEntity = EntityType<
  AddressSuggestion[],
  OperationType
>;

export type AddressSuggestionsError = ErrorState<OperationType>;

export interface AddressSuggestion {
  readonly addressId?: number;
  readonly suggestion: string;
}

export enum OperationType {
  "GET_ADDRESS_SUGGESTIONS",
}
